
export const company = {
  name: "Zentra Group",
  tagline: "Transformamos tu empresa con soluciones tecnológicas a medida.",
  phone: "+569 68585106",
  email: "soporte@zentragroup.cl",
};

export const services = [
  {
    title: "Desarrollo de Software",
    desc:
      "Sistemas a medida, aplicaciones web y móviles para optimizar operaciones y UX.",
  },
  {
    title: "Gestión de Flotas con GPS",
    desc:
      "Monitoreo en tiempo real, estadísticas, alertas y corte de corriente para máxima eficiencia.",
    bullets: [
      "Monitoreo 24/7 con actualización por segundos",
      "Corte de motor remoto y alertas de movimiento",
      "Velocidad, tiempos detenidos y rutas",
      "Apps móviles y web con interfaz moderna",
    ],
  },
  {
    title: "Consultoría en TI",
    desc:
      "Implementación de soluciones, automatización de procesos y elección de herramientas.",
  },
];

export const faqs = [
  {
    q: "¿Qué servicios ofrece Zentra Group?",
    a: "Automatización de procesos, desarrollo de software a medida, consultoría en transformación digital y diseño de soluciones web/móviles.",
  },
  {
    q: "¿Cómo solicito consultoría personalizada?",
    a: "Contáctanos por el formulario de 'Contacto' o al correo soporte@zentragroup.cl.",
  },
  {
    q: "¿Realizan desarrollos a medida?",
    a: "Sí, creamos soluciones personalizadas según necesidades y desafíos de cada cliente.",
  },
  {
    q: "¿Ofrecen soporte post-implementación?",
    a: "Sí, soporte continuo y mantenimiento con actualizaciones y asistencia técnica.",
  },
];

export const pricing = [
  {
    name: "Basic",
    price: 10,
    tag: "Apto para pymes y usuarios individuales",
    features: ["Analítica básica", "Soporte estándar", "Hasta 5 proyectos"],
  },
  {
    name: "Premium",
    price: 20,
    tag: "Para negocios en crecimiento",
    features: [
      "Insights avanzados",
      "Soporte prioritario",
      "Proyectos ilimitados",
      "Integraciones personalizadas",
    ],
  },
  {
    name: "Enterprise",
    price: 50,
    tag: "Funciones avanzadas para organizaciones",
    features: [
      "Soluciones a medida",
      "Soporte 24/7",
      "Seguridad y compliance",
    ],
  },
  {
    name: "Ultimate",
    price: 80,
    tag: "Todo incluido para líderes de la industria",
    features: [
      "Desarrollo a la medida",
      "Soporte premium",
      "Acceso prioritario a nuevas funciones",
    ],
  },
];

export const logos = ["Acme", "Quanta", "Nova", "Globo", "Pulse"];
